import { disabledCSVExportList } from 'components/helpers/variables';

export const isCSVExportVisible = (tableType) =>
	!disabledCSVExportList.some((type) => type === tableType);
